<script setup lang="ts">
import WordleKeyboardKey from "@/components/wordle/WordleKeyboardKey.vue";
import WordleKeyboardRow from "@/components/wordle/WordleKeyboardRow.vue";
import { ref } from "vue";

type Props = {
  correctCharacters: string[];
  presentCharacters: string[];
  wrongCharacters: string[];
};

const props = defineProps<Props>();
const emit = defineEmits<{ (e: "clickKey", key: string): void }>();

const keyboardRows = [
  ["q", "w", "e", "r", "t", "y", "u", "i", "o", "p"],
  ["a", "s", "d", "f", "g", "h", "j", "k", "l"],
  ["enter", "z", "x", "c", "v", "b", "n", "m", "backspace"],
];

const canPress = ref(true);

function clickKey(key: string): void {
  if (canPress.value) {
    canPress.value = false;
    emit("clickKey", key);
    setTimeout(() => {
      canPress.value = true;
    }, 50);
  }
}
</script>
<template>
  <div class="flex w-full flex-col gap-y-2">
    <WordleKeyboardRow v-for="row in keyboardRows" :key="row[0]">
      <WordleKeyboardKey
        v-for="key in row"
        :key="key"
        :keyboard-key="key"
        :is-correct="props.correctCharacters.includes(key)"
        :is-present="props.presentCharacters.includes(key)"
        :is-wrong="props.wrongCharacters.includes(key)"
        @click="clickKey(key)"
      />
    </WordleKeyboardRow>
  </div>
</template>
